import { Component, EventEmitter, HostListener, Inject, OnInit, AfterViewInit, Output, ViewChild } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Observable, Subscription } from 'rxjs';
// import { environment } from 'src/environments/environment';
import { CurrentUser, CurrentUserService } from '../shared/services/current-user.service';
import { MatAccordion } from '@angular/material/expansion';
import { AppEventType, EventQueueService } from '../shared/utils/AppEventType';
import { LastSearchService } from '../shared/services/lastSearchService';
import { FeaturesService } from '../shared/services/features.service';
import { AUTH_CONFIG_TOKEN, EGO_TOKEN, FEATURES_TOKEN, PRODUCT_IDENTITY_TOKEN, PRODUCT_URIS_TOKEN } from '../config/config.tokens';
import { ConfigService } from '../config/config.service';
import { MenuSectionComponent } from './menu-section.component';
import { IConfiguredMenuItem } from './menu.models';
import { MenuFacade } from './menu.facade';
import { AuthConfig, EgoConfig, ProductIdentity, ProductUris } from '../config/config.model';


interface IOptionalMenuItem {
  visible: boolean
}

interface IOptionalMenuLink {
  url: string,
  visible: boolean
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit {
  @Output() itemSelected = new EventEmitter();

  @ViewChild(MatAccordion)
  menuAccordion: MatAccordion;

  // Search
  @ViewChild('searchPanel')
  searchPanel: MenuSectionComponent;

  // EGO
  @ViewChild('egoPanel')
  egoPanel: MenuSectionComponent;

  // Notifications
  @ViewChild('notificationsPanel')
  notificationsPanel: MenuSectionComponent;


  // Reports
  @ViewChild('reportsPanel')
  reportsPanel: MenuSectionComponent;


  // Analysis
  @ViewChild('analysisPanel')
  analysisPanel: MenuSectionComponent;


  // Tools
  @ViewChild('toolsPanel')
  toolsPanel: MenuSectionComponent;

  // Help
  @ViewChild('helpPanel')
  helpPanel: MenuSectionComponent;


  // Your Account
  @ViewChild('yourAccountPanel')
  yourAccountPanel: MenuSectionComponent;


  ret: Observable<any>;
  productAccessManager: IOptionalMenuLink = {
    url: "",
    visible: false
  }
  selfServiceUserManager: IOptionalMenuItem = {
    visible: false
  }
  apiKeyManager: IOptionalMenuItem = {
    visible: false
  }
  apiSandbox: IOptionalMenuItem = {
    visible: false
  }
  assetMarkerEditor: IOptionalMenuItem = {
    visible: false
  }
  dataCentreEditor: IOptionalMenuItem = {
    visible: false
  }
  geographicalProjectPresenter: IOptionalMenuLink = {
    url: "",
    visible: false
  }
  userGuide: IOptionalMenuLink = {
    url: "",
    visible: true // unconditionally visible
  }
  eicAssetMap: IOptionalMenuLink = {
    url: "",
    visible: true // unconditionally visible
  }
  eicSupplyMap: IOptionalMenuLink = {
    url: "",
    visible: true // unconditionally visible
  }
  eicDataStream: IOptionalMenuLink = {
    url: "",
    visible: true // unconditionally visible
  }


  changePasswordUrl: string;

  showSearch: boolean;
  showEgo: boolean;
  
  showNotifications: boolean;

  showReports: boolean;
  showSectorWorkbooks: boolean;
  showNewsBriefs: boolean;
  showPDFReportManager: boolean;

  showAnalysis: boolean;
  showGeographicalProjectPresenter: boolean;

  showTools: boolean;

  showHelp: boolean;

  showYourAccount: boolean;

  expandSearch: boolean;

  isAuthenticated: boolean;

  // feature switches
  isLegacyStartup: boolean;
  isAssetSearchEnabled: boolean
  isRepeatLastSearchEnabled: boolean;
  enableThemeSelector: boolean = false;
  enableAssetMarkerEditor: boolean;
  enableApiKeyManager: boolean;
  enableApiSandbox: boolean;
  enableDataCentreEditor: boolean;

  product: { prefix: string; name: string; fullName: string; };
  //currentUser: CurrentUser;
  isEicAssetMap: boolean = false;
  isSearchMenuExpandedByDefault: boolean = false;
  isEgoLive: boolean = false;
  isEapUser: boolean = false;
  enableDashboardForEicAssetMap: boolean = false;
  enableNewDashboard: boolean = false;
  selectedMenuItemId: string | null = null;
  isNarrowScreen: boolean = false;
  private pendingSelectedMenuItemId: string | null = null;

  private subs = new Subscription();
  enableGeographicalSummary: boolean;
  suspendPdfReportManager: boolean;
  showOffshoreAssets: any;

  constructor(
    @Inject('SearchService') private searchService: any,
    @Inject(FEATURES_TOKEN) private features: FeaturesService,
    @Inject(PRODUCT_IDENTITY_TOKEN) public productIdentity:ProductIdentity,
    @Inject(PRODUCT_URIS_TOKEN) public productAddresses:ProductUris,
    @Inject(AUTH_CONFIG_TOKEN) public authConfig:AuthConfig,
    @Inject(EGO_TOKEN) public egoConfig: EgoConfig,
    
    private $state: StateService,
    private currentUserService: CurrentUserService,
    private eventQueue: EventQueueService,
    private lastSearchService: LastSearchService,
    private configService: ConfigService,
    private menuFacade: MenuFacade,
    //private features: FeaturesService,

  ) { }


  ngOnInit(): void {
    this.updateResponsiveFlags();

    // Product Setting
    this.isEicAssetMap = this.productIdentity.fullName == "EICAssetMap";
    this.isLegacyStartup = this.configService.features().isLegacyStartup;
    this.isAssetSearchEnabled = this.configService.features().isAssetSearchEnabled;
    //this.product = this.productIdentity.fullName;
    this.enableDashboardForEicAssetMap = !!(this.configService.dashboard() && this.configService.dashboard().enableDashboardForEicAssetMap);
    this.enableNewDashboard = !!(this.configService.dashboard() && this.configService.dashboard().enableNewDashboard);
    this.isSearchMenuExpandedByDefault = this.isEicAssetMap && !this.enableDashboardForEicAssetMap;

    this.productAccessManager.url = this.productAddresses.productAccessManager
    this.geographicalProjectPresenter.url = this.productAddresses.geographicalProjectPresenter

    this.userGuide.url = this.productAddresses.userGuide;
    this.eicAssetMap.url = this.productAddresses.eicAssetMap;
    this.eicSupplyMap.url = this.productAddresses.eicSupplyMap;
    this.eicDataStream.url = this.productAddresses.eicDataStream;

    this.changePasswordUrl = `${this.authConfig.changePasswordUrlTemplate}?returnUrl=${this.currentUrl()}`;

    // Determine if on dashboard route (default state also goes to dashboard)
    this.isDashboardSelected = this.$state.includes('dashboard') || this.$state.is('app.dashboardNew') || this.$state.is('');
    this.applyRouteSelection(this.$state.current?.name || '');

    // Set feature switches
    this.isLegacyStartup = this.features.isLegacyStartup;
    this.isAssetSearchEnabled = this.features.isAssetSearchEnabled;
    //this.isAssetSearchEnabled = environment.features.isAssetSearchEnabled;
    this.isRepeatLastSearchEnabled = true;
    // An event service acks as a mediator between the onSuccess 
    // transition hook and the menu. Described here:
    // https://medium.com/@Armandotrue/broadcasting-events-in-angular-b85289a4d685
    this.eventQueue.on(AppEventType.TransitionSuccess)
      .subscribe(event => {
        return this.handleEvent(event.payload)
      });



    // ensure the service is initialised (idempotent)
    this.currentUserService.init();

    // Subscribe to the user observable and react to changes.
    // We always update isAuthenticated from the basic emission.
    // When `full` arrives (enriched data) we compute permission-based flags.
    this.subs.add(
      this.currentUserService.user$.subscribe(u => {
        if (!u) {
          // no user available yet
          this.isAuthenticated = false;
          return;
        }

        // always reflect basic authenticated state immediately
        this.isAuthenticated = !!u.isAuthenticated;

        if (!u.isAuthenticated) {
          // not authenticated -> hide auth-only menu items
          this.showSearch = false;
          this.showEgo = false;
          this.showReports = false;
          // ... set whatever defaults you use
          return;
        }

        // If enrichment is already present, apply permissions now
        if (u.full) {
          this.applyEnrichedUser(u);
          return;
        }

        // If enrichment not yet present, you may optionally wait for it:
        // do nothing here and the subscription will receive the enriched user
        // when it arrives (the same callback will execute again).
      })
    );
  }



  /*
    6	Europe	2
    7	GCC	2
    8	ASEAN	2
    9	Brazil	2
    10	Gulf of Mexico	2
    11	Africa	2
    12	USA	2
    13	Australasia	2
    14	Russia+CIS	2
    18	Italy	2
  */
  private applyEnrichedUser(u: CurrentUser) {
    const localMembershipIds = new Set([6, 7, 8, 9, 10, 11, 12, 13, 14, 18]);
    
    // Example: read effectivePermissions and userDetails from u.full
    const full = u.full!;
    const userDetails = full.userDetails ?? { roles: [] as string[] };
    const isEICStaff = (userDetails.roles || []).includes("EIC Staff");
    const capexPermissions = full.effectivePermissions["CAPEX"];
    const isLocalMembership = capexPermissions.zoneIds.some(item=> localMembershipIds.has(item));
    const isAssetMapProduct = this.productIdentity.fullName === "EICAssetMap";
    const isDataStreamProduct = this.productIdentity.fullName === "EICDataStream";

    this.resetProductMenuLinks();
    const redirected = this.applyProductPermissionRules(u, isDataStreamProduct, isAssetMapProduct);
    if (redirected) {
      return;
    }

    // set menu flags the same way you used to in the commented code
    this.showSearch = true;

    this.showReports = true;
    this.showSectorWorkbooks = u.hasCapex && !this.isEicAssetMap && !isLocalMembership;
    this.showOffshoreAssets = u.hasOpex && (this.isEicAssetMap || this.isAssetSearchEnabled);
    this.showNewsBriefs = true;
    this.showPDFReportManager = u.hasCapex && !this.isEicAssetMap;
    this.showNotifications = u.hasCapex;
    this.showAnalysis = u.hasCapex;
    this.showGeographicalProjectPresenter = isEICStaff;
    this.showTools = true;
    this.showHelp = true;
    this.showYourAccount = true;

    // role-based UI elements (from earlier commented snippet)
    const roles = userDetails.roles || [];
    this.productAccessManager.visible = roles.includes('Product Access Administrator');
    this.selfServiceUserManager.visible = roles.includes('Member Account Manager');
    this.apiKeyManager.visible = roles.includes('Member API Manager');
    this.apiSandbox.visible = roles.includes('Member API Manager');
    this.assetMarkerEditor.visible = roles.includes('Asset Marker Administrator');
    this.dataCentreEditor.visible = roles.includes('Data Centre Editor');
    this.geographicalProjectPresenter.visible = isEICStaff;
    this.isEapUser = roles.includes('EAP User');
    this.isEgoLive = this.egoConfig.isEgoLive;
    this.showEgo = !this.isEicAssetMap && (this.isEgoLive || this.isEapUser);

    // feature flags may be derived from features service as before
    this.enableThemeSelector = this.features.enableThemeSelector;
    this.enableApiKeyManager = this.features.enableApiKeyManager;
    this.enableApiSandbox = this.features.enableApiSandbox;
    this.enableAssetMarkerEditor = this.features.enableAssetMarkerEditor;
    this.enableDataCentreEditor = this.features.enableDataCentreEditor;
    this.enableGeographicalSummary = this.features.enableGeographicalSummary;
    this.suspendPdfReportManager = this.features.legacySwitches?.NEW_REPORT_REQUEST?.SUSPENDED ?? false;

  }

  private resetProductMenuLinks(): void {
    this.eicAssetMap.visible = true;
    this.eicAssetMap.url = this.productAddresses.eicAssetMap;

    this.eicDataStream.visible = true;
    this.eicDataStream.url = this.productAddresses.eicDataStream;

    this.eicSupplyMap.visible = true;
    this.eicSupplyMap.url = this.productAddresses.eicSupplyMap;
  }

  private applyProductPermissionRules(u: CurrentUser, isDataStreamProduct: boolean, isAssetMapProduct: boolean): boolean {
    const hasCapexOnly = !!u.hasCapex && !u.hasOpex;
    const hasOpexOnly = !!u.hasOpex && !u.hasCapex;
    const hasCapexAndOpex = !!u.hasCapex && !!u.hasOpex;

    const eicAssetMapMarketingUrl = this.productAddresses.eicAssetMapMarketing;
    const eicDataStreamMarketingUrl = this.productAddresses.eicDataStreamMarketing;

    if (isDataStreamProduct) {
      this.eicDataStream.visible = false;

      if (hasCapexOnly) {
        this.eicAssetMap.visible = true;
        this.eicAssetMap.url = eicAssetMapMarketingUrl;
        return false;
      }

      if (hasOpexOnly) {
        return this.redirectTo(eicDataStreamMarketingUrl);
      }

      if (hasCapexAndOpex) {
        if (this.features.isLegacyStartup) {
          this.eicAssetMap.visible = true;
        }
        else {
          this.eicAssetMap.visible = false;
        }
        return false;
      }

      return this.redirectTo(eicDataStreamMarketingUrl);
    }

    if (isAssetMapProduct) {
      this.eicAssetMap.visible = false;

      if (hasCapexOnly) {
        // this.eicDataStream.visible = true;
        // this.eicDataStream.url = eicDataStreamMarketingUrl;
        return this.redirectTo(eicAssetMapMarketingUrl);
      }

      if (hasOpexOnly) {
        this.eicDataStream.visible = true;
        this.eicDataStream.url = eicDataStreamMarketingUrl;
        return false;
      }

      if (hasCapexAndOpex) {
        if (this.features.isLegacyStartup) {
          this.eicDataStream.visible = true;
          this.eicDataStream.url = this.productAddresses.eicDataStream;
        }
        else {
          if (this.isAssetSearchEnabled) {
            return this.redirectTo(this.productAddresses.eicDataStream);
          }
        }

        return false;
      }

      return this.redirectTo(eicAssetMapMarketingUrl);
    }

    return false;
  }

  private redirectTo(url: string): boolean {
    if (!url) {
      return false;
    }

    window.location.href = url;
    return true;
  }


  handleEvent(payload: any) {
    // When a successful transition occurs, evaluate
    // the from and to states to decide what parts of
    // the menu should be activated.
    //
    // Strategy
    // --------
    // 1. Check for transition sequences that should be ignored
    //    - search preceeded by search.forProjects
    //    - search preceeded by search.forContractAwards
    // 2. split the 'to' route into section and route parts
    // 3. perform main and subswitches where necessary
    // 4. Open the section panel
    // 5. set the rout selection to selected


    if (payload.to == "search"
      && (payload.from == "search.forProjects"
        || payload.from == "search.forContractAwards")) {
      // ignore this transition
    }
    else {
      this.applyRouteSelection(payload.to);

    }

    if (this.pendingSelectedMenuItemId) {
      this.searchPanel?.open();
      this.selectedMenuItemId = this.pendingSelectedMenuItemId;
      this.pendingSelectedMenuItemId = null;
    }

  }

  private applyRouteSelection(stateName: string): void {
    const to = (stateName || '').split('.');
    const section = to[0];
    const route = to[1];

    this.isDashboardSelected = section === 'dashboard' || stateName === 'app.dashboardNew' || route === 'dashboardNew' || stateName === '';
    this.selectedMenuItemId = null;

    if (this.isDashboardSelected) {
      return;
    }

    switch (section) {
      case 'search':
        this.searchPanel?.open();
        if (route === 'projectSummary' || route === 'forProjects') {
          this.selectedMenuItemId = 'mnuSearch-CapexProjects';
        }
        if (route === 'contractAwardSummary' || route === 'forContractAwards') {
          this.selectedMenuItemId = 'mnuSearch-Contracts';
        }
        break;

      case 'assets':
        this.searchPanel?.open();
        if (route === 'search') {
          this.selectedMenuItemId = 'mnuSearch-Assets';
        }
        break;

      case 'ego':
        this.egoPanel?.open();
        //this.selectedMenuItemId = 'mnuEgo-EGO';
        break;

      case 'notifications':
        this.notificationsPanel?.open();
        break;

      case 'notificationCentre':
        this.notificationsPanel?.open();
        this.selectedMenuItemId = 'mnuNotifications-NotificationCentre';
        break;

      case 'projectWatch':
        this.notificationsPanel?.open();
        this.selectedMenuItemId = 'mnuNotifications-NotificationCentre';
        break;

      case 'analysis':
        this.analysisPanel?.open();
        break;

      case 'geographicalSummary':
        this.analysisPanel?.open();
        this.selectedMenuItemId = 'mnuAnalysis-GeographicalSummary';
        break;

      case 'reports':
        this.reportsPanel?.open();
        switch (route) {
          case 'insightReports':
            this.selectedMenuItemId = 'mnuReports-InsightReports';
            break;

          case 'countryReports':
            this.selectedMenuItemId = 'mnuReports-CountryReports';
            break;

          case 'opexReports':
            this.selectedMenuItemId = 'mnuReports-OpexReports';
            break;

          case 'businessReports':
            this.selectedMenuItemId = 'mnuReports-BusinessReports';
            break;

          case 'sectorWorkbooks':
            this.selectedMenuItemId = 'mnuReports-SectorWorkbooks';
            break;

          case 'offshoreAssets':
            this.selectedMenuItemId = 'mnuReports-OffshoreAssets';
            break;

          case 'newsBriefs':
            this.selectedMenuItemId = 'mnuReports-NewsBriefs';
            break;

          case 'managePdfReports':
            this.selectedMenuItemId = 'mnuReports-ManagePdfReports';
            break;
        }
        break;

      case 'userManager':
        this.toolsPanel?.open();
        this.selectedMenuItemId = 'mnuTools-SelfServiceUserManager';
        break;

      case 'keyManager':
        this.toolsPanel?.open();
        this.selectedMenuItemId = 'mnuTools_ApiKeyManager';
        break;

      case 'apiSandbox':
        this.toolsPanel?.open();
        this.selectedMenuItemId = 'mnuTools_ApiSandbox';
        break;

      case 'assetmarkereditor':
        this.toolsPanel?.open();
        this.selectedMenuItemId = 'mnuTools_AssetMarkerEditor';
        break;

      case 'datacentreeditor':
        this.toolsPanel?.open();
        this.selectedMenuItemId = 'mnuTools_DataCentreEditor';
        break;

      case 'help':
        this.helpPanel?.open();
        if (route === 'supportedPlatforms') {
          this.selectedMenuItemId = 'mnuHelp-SupportedPlatforms';
        }
        break;

      case 'userAccount':
        this.yourAccountPanel?.open();
        this.selectedMenuItemId = 'mnuYourAccount-AccountDetails';
        break;
    }
  }

  isMenuItemSelected(menuItemId: string): boolean {
    return this.selectedMenuItemId === menuItemId;
  }

  onExternalMenuItemClick(): void {
    this.itemSelected.emit({ clicked: true });
  }

  onConfiguredMenuItemClick(item: IConfiguredMenuItem): void {
    if (item.disabled || !item.onClick) {
      return;
    }

    item.onClick();
  }

  get reportsMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildReportsMenuItems({
      isEicAssetMap: this.isEicAssetMap,
      showSectorWorkbooks: this.showSectorWorkbooks,
      showOffshoreAssets: this.showOffshoreAssets,
      showNewsBriefs: this.showNewsBriefs,
      showPDFReportManager: this.showPDFReportManager,
      suspendPdfReportManager: this.suspendPdfReportManager,
      onInsightReports: () => this.clickInsightReports(),
      onOpexReports: () => this.clickOpexReports(),
      onCountryReports: () => this.clickCountryReports(),
      onOffshoreAssets: () => this.clickOffshoreAssets(),
      onSectorWorkbooks: () => this.clickSectorWorkbooks(),
      onNewsBriefs: () => this.clickNewsBriefs(),
      onManagePdfReports: () => this.clickManagePdfReports()
    });
  }

  get toolsMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildToolsMenuItems({
      selfServiceUserManagerVisible: this.selfServiceUserManager.visible,
      apiKeyManagerVisible: this.apiKeyManager.visible,
      enableApiKeyManager: this.enableApiKeyManager,
      apiSandboxVisible: this.apiSandbox.visible,
      enableApiSandbox: this.enableApiSandbox,
      assetMarkerEditorVisible: this.assetMarkerEditor.visible,
      enableAssetMarkerEditor: this.enableAssetMarkerEditor,
      dataCentreEditorVisible: this.dataCentreEditor.visible,
      enableDataCentreEditor: this.enableDataCentreEditor,
      productAccessManagerVisible: this.productAccessManager.visible,
      productAccessManagerUrl: this.productAccessManager.url,
      onUserManager: () => this.clickUserManager(),
      onApiKeyManager: () => this.clickApiKeyManager(),
      onApiSandbox: () => this.clickApiSandbox(),
      onAssetMarkerEditor: () => this.clickAssetMarkerEditor(),
      onDataCentreEditor: () => this.clickDataCentreEditor()
    });
  }

  get searchMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildSearchMenuItems({
      isEicAssetMap: this.isEicAssetMap,
      isNarrowScreen: this.isNarrowScreen,
      isRepeatLastSearchEnabled: this.isRepeatLastSearchEnabled,
      isAssetSearchEnabled: this.isAssetSearchEnabled,
      isEapUser: this.isEapUser,
      showSearchSeparator: this.showSearchSeparator,
      onSavedSearches: () => this.clickSavedSearches(),
      onProjects: () => this.clickSearchProjects(),
      onProjectsMobile: () => this.clickSearchProjectsMobile(),
      onContracts: () => this.clickSearchContractAwards(),
      onContractsMobile: () => this.clickSearchContractAwardsMobile(),
      onRepeatLastSearch: () => this.clickRepeatLastSearch(),
      onAssets: () => this.clickSearchAssets()
      
    });
  }
//onEgo: () => this.clickEgo()
  get egoMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildEgoMenuItems({
      isEicAssetMap: this.isEicAssetMap,
      isEapUser: this.isEapUser,
      isEgoLive: this.isEgoLive,
      onEgo: () => this.clickEgo()
    });
  }

  get showSearchSeparator(): boolean {
    return this.isAssetSearchEnabled && !this.isEicAssetMap;
  }

  get notificationMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildNotificationMenuItems({
      onNotifications: () => this.clickNotifications()
    });
  }

  get analysisMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildAnalysisMenuItems({
      enableGeographicalSummary: this.enableGeographicalSummary,
      geographicalProjectPresenterVisible: this.geographicalProjectPresenter.visible,
      geographicalProjectPresenterUrl: this.geographicalProjectPresenter.url,
      onGeographicalSummary: () => this.clickGeographicalSummary()
    });
  }

  get productsMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildProductsMenuItems({
      eicAssetMapVisible: this.eicAssetMap.visible,
      eicAssetMapUrl: this.eicAssetMap.url,
      eicDataStreamVisible: this.eicDataStream.visible,
      eicDataStreamUrl: this.eicDataStream.url,
      eicSupplyMapUrl: this.eicSupplyMap.url
    });
  }

  get helpMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildHelpMenuItems({
      isEicAssetMap: this.isEicAssetMap,
      userGuideUrl: this.userGuide.url,
      onSupportedPlatforms: () => this.clickSupportedPlatforms(),
      onAssetMapUserGuide: () => this.clickAssetMapUserGuide()
    });
  }

  get yourAccountMenuItems(): IConfiguredMenuItem[] {
    return this.menuFacade.buildYourAccountMenuItems({
      isAuthenticated: this.isAuthenticated,
      changePasswordUrl: this.changePasswordUrl,
      onUserInfo: () => this.clickUserInfo(),
      onLogout: () => this.clickLogout(),
      onLogin: () => this.clickLogin()
    });
  }


  ngAfterViewInit(): void {

  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateResponsiveFlags();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }


  currentUrl(): string {
    return window.location.href;
  }

  private updateResponsiveFlags(): void {
    this.isNarrowScreen = window.innerWidth <= 500;
  }


  onMenuSectionClick(section: string): void {
    this.isDashboardSelected = false;
    // If you need to map back to your data, bind a template var or an id on the panel
    console.log('Accordion selection changed', section);
  }

  // This is a problem - the real value depends on the current route. 
  // It needs to be set correctly on init and on every transition. The
  // menu should be a reflection of the current route, not a source 
  // of truth. This is currently being set in the handleEvent method, 
  // but it would be better to compute it from the route directly (e.g.
  // by checking if the current route starts with 'dashboard').
  isDashboardSelected = true;

  clickDashboard(): void {
    this.isDashboardSelected = true;
    this.selectedMenuItemId = null;
    this.menuAccordion.closeAll();

    this.itemSelected.emit({ clicked: true });

    this.$state.go(this.enableNewDashboard ? 'app.dashboardNew' : 'dashboard');
  }

  clickSearchContractAwards(): void {
    this.isDashboardSelected = false;


    this.itemSelected.emit({ clicked: true });

    this.searchService.searchType = 'contractAward';
    this.$state.go('search.forContractAwards');
  }
  clickSearchContractAwardsMobile(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('unavailable', { "module": "search", "function": "contractawards", "reason": "mobile" });
  }

  clickSearchProjects(): void {
    this.itemSelected.emit({ clicked: true });
    this.searchService.searchType = 'project';

    this.$state.go('search.forProjects');
  }
  clickSearchProjectsMobile(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('unavailable', { "module": "search", "function": "projects", "reason": "mobile" });
  }

  clickSearchAssets(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('assets.search');
  }

  clickEgo(): void {
    this.itemSelected.emit({ clicked: true });
    this.$state.go('ego');
  }

  clickRepeatLastSearch(): void {
    this.itemSelected.emit({ clicked: true });
    this.isDashboardSelected = false;
    this.searchPanel?.open();
    this.selectedMenuItemId = 'mnuSearch-RepeatLastSearch';
    this.pendingSelectedMenuItemId = 'mnuSearch-RepeatLastSearch';
    // need t look up the last  search and repeat it

    // core logic needed to repeat the last search
    // lastSearch is an AngularJS resource. Trouble 
    // is, it needs to be rewritten for use in Angular
    // EICDataStream3Resources.factory('lastSearch', ['$resource', function ($resource) {
    //   return $resource('/api/lastSearch');
    // }]);
    // It should be easy enough to write a service to 
    // access this endpoint and then include it in the 
    // route resolver function. it doesn't seem right
    // to put that logic here. At minimum, the menu 
    // should ask a service to compute the new state 
    // and do the transfer  
    this.lastSearchService.getLastSearch()
      .subscribe(ls => {
        this.$state.go(ls.newState, ls.stateArgs);
      })

      ;


  }

  clickSavedSearches(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('search');
  }

  clickNotifications(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('notificationCentre');
  }


  // Reportsng sub-menu
  clickInsightReports(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('reports.insightReports');
  }

  clickCountryReports(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('reports.countryReports');
  }

  clickOpexReports(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('reports.opexReports');
  }

  clickOffshoreAssets(): void {
    this.itemSelected.emit({ clicked: true })

    this.$state.go('reports.offshoreAssets')
  }

  clickBusinessReports(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('reports.businessReports');
  }

  clickSectorWorkbooks(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('reports.sectorWorkbooks');
  }

  clickNewsBriefs(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('reports.newsBriefs');
  }

  clickManagePdfReports(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('reports.managePdfReports')
      .catch(() => this.$state.go('reports')
        .then(() => this.$state.go('reports.managePdfReports')));
  }


  // Help sub-menu
  clickSupportedPlatforms(): void {
    this.$state.go('help.supportedPlatforms');
    this.itemSelected.emit({ clicked: true });
  }
  clickAssetMapUserGuide(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('help.assetMapUserGuide');
  }

  // Tools Sub-menu 
  // - User Manager Module
  clickUserManager(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('userManager');
  }

  // - API Key Manager Module  
  clickApiKeyManager(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('keyManager');
  }

  clickApiSandbox(): void {
    this.itemSelected.emit({ clicked: true });  
  
    this.$state.go('apiSandbox');
  }

  // - API Key Manager Module  
  clickAssetMarkerEditor(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('assetmarkereditor.list');
  }
  // - Data Centre Editor Module
  clickDataCentreEditor(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('datacentreeditor');
  }

  clickGeographicalSummary(): void {
    this.itemSelected.emit({ clicked: true });

    this.$state.go('geographicalSummary');
  }

  clickLogin(): void {
    // Set the location to the BFF login endpoint
    // This needs to be wrapped so that  it can be
    // called with a return URL
    // window.location.href = "/bff/login?returnUrl=/";
    this.currentUserService.login(this.currentUrl());
  }

  clickUserInfo(): void {
    this.itemSelected.emit({ clicked: true });
    this.$state.go('userAccount.fullDetails');

  }

  clickLogout(): void {
    this.currentUserService.logout();
    //window.location.href = this.currentUser.logoutUrl;
  }
}
